import React from 'react';
import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';
import Typography from '@mui/material/Typography';

const toneMap = {
  forest: {
    border: '#7fc34d',
    bg: 'linear-gradient(180deg, #effbdc 0%, #dff7c6 100%)',
    title: '#166534',
    metricBg: '#f8fff0',
    metricIconBg: '#dbeafe',
  },
  library: {
    border: '#93c5fd',
    bg: 'linear-gradient(180deg, #eef7ff 0%, #dcebff 100%)',
    title: '#1d4ed8',
    metricBg: '#f8fbff',
    metricIconBg: '#dbeafe',
  },
  stars: {
    border: '#f6c453',
    bg: 'linear-gradient(180deg, #fff6d9 0%, #ffedbd 100%)',
    title: '#c2410c',
    metricBg: '#fffaf0',
    metricIconBg: '#fef3c7',
  },
};

export default function ClassStatTile({
  type,
  icon,
  title,
  metricIcon,
  label,
  children,
  onClick,
  interactiveLabel,
}) {
  const tone = toneMap[type] || toneMap.library;
  const TileRoot = onClick ? ButtonBase : Box;
  return (
    <TileRoot
      {...(onClick ? { onClick, 'aria-label': interactiveLabel || title } : {})}
      sx={{
        position: 'relative',
        width: '100%',
        borderRadius: 2,
        border: `3px solid ${tone.border}`,
        bgcolor: '#fff',
        background: tone.bg,
        minHeight: { xs: 210, md: 244 },
        p: { xs: 1.2, md: 1.4 },
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        overflow: 'hidden',
        boxShadow: '0 6px 0 rgba(15,23,42,0.06), inset 0 0 0 2px rgba(255,255,255,0.68)',
        textAlign: 'inherit',
        ...(onClick ? {
          cursor: 'pointer',
          transition: 'transform 160ms ease, box-shadow 160ms ease',
          '&:hover, &:focus-visible': {
            transform: 'translateY(-3px)',
            boxShadow: `0 9px 0 rgba(15,23,42,0.09), 0 15px 22px ${tone.border}66, inset 0 0 0 2px rgba(255,255,255,0.68)`,
          },
          '&:focus-visible': { outline: '4px solid #7c3aed', outlineOffset: 3 },
        } : {}),
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.8, mb: 0.4, zIndex: 1, minWidth: 0 }}>
        <Box component="span" aria-hidden="true" sx={{ width: 32, height: 32, flex: '0 0 32px', display: 'grid', placeItems: 'center' }}>{icon}</Box>
        <Typography sx={{ fontWeight: 1000, color: tone.title, fontSize: { xs: 21, md: 26 }, lineHeight: 1.05, textAlign: 'center' }}>
          {title}
        </Typography>
      </Box>
      {onClick && (
        <Typography sx={{ color: tone.title, fontWeight: 1000, fontSize: { xs: 14, md: 16 }, textAlign: 'center', mb: 0.2 }}>
          {interactiveLabel || 'Dokunarak görüntüle'}
        </Typography>
      )}

      <Box sx={{ flex: 1, minHeight: 0, width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1 }}>
        {children}
      </Box>

      <Box
        sx={{
          position: 'relative',
          zIndex: 2,
          mt: 0.8,
          mx: { xs: 0.4, md: 1 },
          borderRadius: 2,
          bgcolor: tone.metricBg,
          border: '1px solid rgba(255,255,255,0.8)',
          boxShadow: '0 4px 12px rgba(15,23,42,0.10)',
          px: { xs: 1, md: 1.2 },
          py: { xs: 0.8, md: 1 },
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          minHeight: 52,
        }}
      >
        <Box
          sx={{
            width: 38,
            height: 38,
            flex: '0 0 38px',
            borderRadius: '50%',
            bgcolor: tone.metricIconBg,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: tone.title,
            boxShadow: 'inset 0 -3px 0 rgba(15,23,42,0.08)',
          }}
        >
          {metricIcon}
        </Box>
        <Typography sx={{ flex: 1, minWidth: 0, color: '#1f2937', fontWeight: 900, fontSize: { xs: 16, md: 18 }, lineHeight: 1.2, textAlign: 'center' }}>
          {label}
        </Typography>
      </Box>
    </TileRoot>
  );
}
